module.exports = __webpack_public_path__ + "static/media/trigo.5dc84035.png";